document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("header");
  if (!header) return;

  // Target both normal links and dropdown triggers
  const candidates = header.querySelectorAll("a, summary, button, span");

  candidates.forEach((el) => {
    const text = (el.textContent || "").trim().toLowerCase();
    if (text === "outlet") {
      el.classList.add("nav-outlet");

      // If Outlet text is inside a wrapper, also tag the closest clickable parent
      const clickable = el.closest("a, summary, button");
      if (clickable) clickable.classList.add("nav-outlet");
    }
  });
});